<template>
  <b-card>
    <b-card-title
      ><h3>{{ pageTitle }}</h3>
    </b-card-title>
    <validation-observer ref="applicationValidation">
      <b-form @submit.prevent>
        <b-row
          ><b-col class="mb-1" md="6">
            <validation-provider
              #default="{ errors }"
              name="appName"
              rules="required"
            >
              <div class="form-label-group">
                <b-form-input
                  id="appName"
                  placeholder="نام اپلیکیشن..."
                  v-model="appName"
                />
                <small class="text-danger">{{ errors[0] }}</small>
                <label for="appName">نام اپلیکیشن</label>
              </div></validation-provider
            ></b-col
          >
          <b-col md="6" class="mb-1">
            <validation-provider
              #default="{ errors }"
              name="androidPackageName"
              rules="required"
            >
              <div class="form-label-group">
                <b-form-input
                  id="androidPackageName"
                  placeholder="پکیج اندروید"
                  v-model="androidPackageName"
                />
                <small class="text-danger"> {{ errors[0] }}</small>
                <label for="androidPackageName">نام پکیج اندروید</label>
              </div>
            </validation-provider>
          </b-col>
          <b-col md="6" class="mb-1">
            <validation-provider
              #default="{ errors }"
              ref="iconProvider"
              name="iconFile"
              rules="required|image|maxdimensions:512,512|size:600"
            >
              <div class="form-label-group">
                <b-form-file
                  id="iconFile"
                  placeholder="آیکون هدف را انتخاب یا کشیده و اینجا رها کنید"
                  drop-placeholder="آیکون را اینجا رها کنید"
                  v-model="iconFile"
                />
                <small class="text-danger"> {{ errors[0] }}</small>
                <label for="iconFile">آیکون</label>
              </div>
            </validation-provider>
          </b-col>
          <b-col md="6" class="mb-1">
            <div class="form-label-group">
              <b-img
                v-if="iconFile"
                center
                :src="iconSrc"
                class="mb-1"
                style="height: 200px"
              />
              <b-button
                v-if="showIconUploadButton"
                block
                variant="primary"
                @click="uploadIcon(updateIconUploadPercentage)"
                >آپلود</b-button
              >
              <b-progress
                v-else-if="iconUploadProgress !== -1"
                animated
                max="100"
                class="progress-bar-success"
              >
                <b-progress-bar
                  :value="iconUploadProgress"
                  :label="`${iconUploadProgress.toFixed(1)}%`"
                  variant="success"
                />
              </b-progress>
            </div>
          </b-col>
          <b-col md="6" class="mb-1">
            <validation-provider
              #default="{ errors }"
              name="category"
              rules="required"
            >
              <div class="form-label-group">
                <b-form-select id="category" v-model="category">
                  <b-form-select-option :value="null"
                    >دسته بندی اپلیکیشن</b-form-select-option
                  >
                  <b-form-select-option :value="0">دسته 1</b-form-select-option>
                  <b-form-select-option :value="1">دسته 2</b-form-select-option>
                  <b-form-select-option :value="2">دسته 3</b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <label for="category">دسته بندی</label>
              </div>
            </validation-provider>
          </b-col>
          <b-col md="6" class="mb-1">
            <validation-provider
              #default="{ errors }"
              name="orientation"
              rules="required"
            >
              <div class="form-label-group">
                <b-form-select id="category" v-model="orientation">
                  <b-form-select-option :value="null"
                    >جهت اپلیکیشن</b-form-select-option
                  >
                  <b-form-select-option :value="0">عمودی</b-form-select-option>
                  <b-form-select-option :value="1">افقی</b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <label for="category">جهت</label>
              </div>
            </validation-provider>
          </b-col>
          <b-col md="6" class="mb-1">
            <validation-provider
              #default="{ errors }"
              name="ageRange"
              rules="required"
            >
              <div class="form-label-group">
                <b-form-select id="ageRange" v-model="ageRange">
                  <b-form-select-option :value="null"
                    >رده سنی اپلیکیشن</b-form-select-option
                  >
                  <b-form-select-option :value="0"
                    >5 الی 10</b-form-select-option
                  >
                  <b-form-select-option :value="1"
                    >11 الی 20</b-form-select-option
                  >
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <label for="category">رده سنی</label>
              </div>
            </validation-provider>
          </b-col>
        </b-row>
        <b-button type="submit" @click="validateForm" block variant="primary"
          >ثبت</b-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BForm,
  BRow,
  BCol,
  BFormInput,
  BFormFile,
  BButton,
  BImg,
  BFormSelect,
  BFormSelectOption,
  BProgress,
  BProgressBar,
} from 'bootstrap-vue'

import { ValidationObserver, ValidationProvider, localize } from 'vee-validate'
import { required } from '@validations'
import fa from 'vee-validate/dist/locale/fa.json'

import axios from '@axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { image, size, maxDimensions } from '../../libs/utils/validations'

export default {
  components: {
    BCard,
    BCardTitle,
    BForm,
    BRow,
    BCol,
    BFormInput,
    BFormFile,
    BButton,
    BImg,
    BFormSelect,
    BFormSelectOption,
    BProgress,
    BProgressBar,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      appName: '',
      androidPackageName: '',
      iconFile: null,
      iconUrl: '',
      iconUploadProgress: -1,
      isIconValid: false,
      category: null,
      orientation: null,
      ageRange: null,
      required,
      image,
      size,
      maxDimensions,
    }
  },
  computed: {
    pageTitle() {
      if (this.id) {
        return 'ویرایش'
      }
      return 'اپلیکیشن جدید'
    },
    iconSrc() {
      if (this.iconFile && this.iconUrl === '') {
        return URL.createObjectURL(this.iconFile)
      }
      if (this.iconUrl !== '') {
        return this.iconUrl
      }
      return null
    },
    showIconUploadButton() {
      if (this.iconFile) {
        if (this.iconUrl === '') {
          if (this.isIconValid) {
            return true
          }
        }
      }
      return false
    },
  },
  watch: {
    iconFile() {
      this.validateIcon().then(result => {
        if (result) {
          this.isIconValid = true
        } else {
          this.isIconValid = false
        }
      })
    },
  },
  created() {
    localize({
      fa: {
        messages: {
          ...fa.messages,
          maxdimensions: (field, arg) => `ابعاد ${field} باید کمتر از ${arg[0]} * ${arg[1]} باشد`,
        },
        names: {
          appName: 'نام اپلیکیشن',
          androidPackageName: 'نام پکیج اندروید',
          iconFile: 'آیکون',
          category: 'دسته بندی',
          orientation: 'جهت اپلیکیشن',
          ageRange: 'رده سنی',
        },
      },
    })
    localize('fa')
  },
  methods: {
    uploadIcon(onProgress) {
      const formData = new FormData()
      formData.append('file', this.iconFile)
      const config = {
        onUploadProgress(progressEvent) {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          )

          if (onProgress) onProgress(percentCompleted)
        },
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
      axios.post('/apps/uploadIcon', formData, config).then(response => {
        if (response.data.success) {
          this.iconUrl = `\\${response.data.data.iconUrl}`
        }
      })
    },
    updateIconUploadPercentage(percentCompleted) {
      this.iconUploadProgress = percentCompleted
    },
    async validateIcon() {
      const validationresult = await this.$refs.iconProvider.validate()

      if (validationresult && validationresult.valid) {
        return true
      }
      return false
    },
    validateForm() {
      this.$refs.applicationValidation.validate().then(success => {
        if (!success) return
        if (this.iconUrl === '') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'ابتدا آیکون را آپلود کنید',
              icon: 'InfoIcon',
              variant: 'info',
            },
          })
          return
        }
        axios
          .post('/apps/new', {
            AppName: this.appName,
            AndroidPackageName: this.androidPackageName,
            Category: this.category,
            Orientation: this.orientation,
            AgeRange: this.ageRange,
            IconUrl: this.iconUrl,
          })
          .then(response => {
            if (response.status !== 200) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'خطایی رخ داده است',
                  icon: 'InfoIcon',
                  variant: 'info',
                },
              })
              return
            }

            if (!response.data.success) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: response.data.message,
                  icon: 'AlertCircleIcon',
                  variant: 'danger',
                },
              })
            } else {
              this.$swal({
                title: 'ذخیره شد.',
                confirmButtonText: 'باشه',
                icon: 'success',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
                allowOutsideClick: false,
              }).then(() => {
                this.$refs.applicationValidation.reset()
                this.clearForm()
              })
            }
          })
      })
    },
    clearForm() {
      this.appName = ''
      this.androidPackageName = ''
      this.iconFile = null
      this.iconUrl = ''
      this.iconUploadProgress = -1
      this.isIconValid = false
      this.category = null
      this.orientation = null
      this.ageRange = null
    },
  },
}
</script>
